import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { AppMessage, AppMessageType, DownloadFileData } from '../../shared/types/webview.types';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class WebViewService {
  public isReactNativeWebView = signal(false);
  public isWebViewReady = signal(false);

  constructor(
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.initializeWebView();
  }

  // ===== INICIALIZACIÓN =====
  private initializeWebView(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.detectReactNativeWebView();
  }

  private detectReactNativeWebView(): void {
    const isReactNative = !!(window as any).ReactNativeWebView;
    this.isReactNativeWebView.set(isReactNative);
    this.isWebViewReady.set(true);
  }

  // ===== COMUNICACIÓN CON REACT NATIVE =====

  private sendToReactNative(type: AppMessageType, data: any = {}): void {
    if (!isPlatformBrowser(this.platformId)) {     
      return;
    }

    if (!(window as any).ReactNativeWebView) {
      console.warn('Not in React Native WebView, message not sent:', { type, data });
      return;
    }

    const message: AppMessage = {
      type,
      payload: data,
      timestamp: new Date().toISOString()
    };

    try {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
    } catch (error) {
      console.error('Error sending message to React Native:', error);
    }
  }

  sendLogoutRequest(): void {
    this.sendToReactNative(AppMessageType.LOGOUT_REQUEST, {});
  }

  sendPqrsCreated(): void {
    this.sendToReactNative(AppMessageType.PQRS_CREATED, {});
  }

  sendBackNative(): void {
    this.sendToReactNative(AppMessageType.BACK_NATIVE, {});
  }

  sendUnauthorized(): void {
    this.sendToReactNative(AppMessageType.UNAUTHORIZED, {});
  }

  sendDownloadFile(fileData: DownloadFileData): void {
    this.sendToReactNative(AppMessageType.DOWNLOAD_FILE, fileData);
  }

  // ===== MÉTODOS PÚBLICOS =====
  logout(): void {
    // Ejecutar logout en AuthService (solo manejo de estado)
    this.authService.logout();
    
    // Enviar mensaje a React Native
    this.sendLogoutRequest();
  }
}
